import { Text } from "@bps/fluent-ui";
import { IInvoiceRow } from "@modules/billing/screens/acc-invoices/components/AccInvoiceTransactionsList.tsx";

export const TransactionProvider: React.FC<IInvoiceRow> = ({ invoice }) => {
  return <Text>{invoice.userNameWithTitle}</Text>;
};
